module.exports = __webpack_public_path__ + "img/openMark-light01.e7d3fa79.png";